import { useParams } from "react-router";
import { useEffect } from "react";
import FormType from "enums/FormType";

import { loadScorable } from "features/scorable/scorableSlice";
import { SurveyPublished } from "features/scorable/Survey";
import { useAppDispatch } from "app/hooks";

export function SurveyRoute() {
    const { surveyId } = useParams();

    const dispatch = useAppDispatch();
    useEffect(() => {
        if (surveyId) {
            dispatch(
                loadScorable({
                    formType: FormType.SURVEY,
                    surveyId,
                })
            );
        }
    }, [dispatch, surveyId]);

    return <SurveyPublished />;
}
